import { GET_STUDENT_SPO_EDUCATION } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponseObject, SpoEducation } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentSpoEducationState = ICommonResponseObject<SpoEducation>;

const initialState: StudentSpoEducationState = {
  content: {
    profEducations: [],
    practices: [],
  },
  loading: false,
};
const generic = genericReducers<StudentSpoEducationState>();
const studentSpoEducation: IReducers<StudentSpoEducationState> = {
  [GET_STUDENT_SPO_EDUCATION[REQUEST]]: generic.get.request,
  [GET_STUDENT_SPO_EDUCATION[SUCCESS]]: generic.get.success,
  [GET_STUDENT_SPO_EDUCATION[FAILURE]]: generic.get.failure,
  [GET_STUDENT_SPO_EDUCATION[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentSpoEducation);
